import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  selectSignUpType,
  selectSignUpInvite,
} from '../../../redux/auth/selectors';

import { get } from 'lodash';

import { TYPE_GENERIC_BUSINESS, SELECT } from '../config';

import InviteStatus from './InviteStatus';
import header from '../assets/header.png';
import header_business from '../assets/header_business.png';

const SignUpBanner = ({ type, location, isHomeowner, inviteData }) => (
  <div
    style={{
      position: 'relative',
      maxHeight: 140,
      height: '23vw',
    }}
  >
    <div
      style={{
        height: '100%',
        width: '100%',
        background: inviteData
          ? '#F1F4FD'
          : `url(${
              (type === TYPE_GENERIC_BUSINESS &&
                get(location, 'pathname') !== SELECT) ||
              !isHomeowner
                ? header_business
                : header
            })`,
        backgroundPosition: 'center',
      }}
    />

    <InviteStatus />
  </div>
);

SignUpBanner.propTypes = {
  type: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  isHomeowner: PropTypes.bool,
};

SignUpBanner.defaultProps = {
  location: null,
  isHomeowner: true,
};

const mapStateToProps = state => ({
  type: selectSignUpType(state),
  inviteData: selectSignUpInvite(state),
});

export default connect(mapStateToProps)(SignUpBanner);
